export default __webpack_public_path__ + "static/media/firs.9b0efdd0.jpeg";